/**
 * Created by Bart Decorte
 * Date: 2019-09-15
 * Time: 12:38
 */
import Page from '../Page';
import DirtyUnloadNotifier from '../../utils/DirtyUnloadNotifier';

export default class AppsEdit extends Page {
  constructor() {
    super();
    new DirtyUnloadNotifier('.js-dirty-unload-notify');
    this.bindListeners();
    this.bindKeys(this.keyBindings());
  }

  bindListeners() {
    const $pageHeading = $('.js-page-header');
    $pageHeading.find('.js-btn-save').on('click', (ev) => {
      return this.lHeadingBtnSaveClick(ev);
    });
  }

  keyBindings() {
    const bindings = super.keyBindings();
    const scope = this;
    return {
      ...bindings,
      'mod+s': (ev) => scope.lModS(ev),
    };
  }

  lModS(ev) {
    ev.preventDefault();
    this.submitForm();
    return false;
  }

  lHeadingBtnSaveClick(ev) {
    ev.preventDefault();
    this.submitForm();
    return false;
  }

  submitForm() {
    $('.js-app-form .js-btn-save')
      .get(0)
      .click();
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Apps/AppsEdit.js